function applyEPPDiscount(eppTag, priceContainerId, productPrice, originalPriceHtml) {
    if (document.querySelector(".eppPricing" + priceContainerId)){
        return
    }
    const eppPartner = sessionStorage.getItem('eppPartner');
    let eppSiteDiscount = sessionStorage.getItem('eppSiteDiscount');
    eppSiteDiscount = parseFloat(eppSiteDiscount) / 100;
    let eppPartnerDiscount = sessionStorage.getItem('eppPartnerDiscount');
    eppPartnerDiscount = parseFloat(eppPartnerDiscount) / 100;

    if (eppPartner) {
        const priceElement = document.getElementById(priceContainerId);
        const productPriceValue = parseFloat(productPrice.replace(',', ''));

        if (eppPartner.toLowerCase() === eppTag.toLowerCase()) {
            const discountedPrice = (productPriceValue * (1 - eppPartnerDiscount)).toFixed(2);

            const ogPrice = document.createElement('p');
            ogPrice.innerHTML = originalPriceHtml;
            ogPrice.className = 'collection_product_card_price';
            ogPrice.classList.add("eppPricing");
            ogPrice.classList.add("eppPricing" + priceContainerId);
            ogPrice.style.textDecoration = 'line-through';
            priceElement.parentNode.insertBefore(ogPrice, priceElement);

            const eppNotice = document.createElement('p');
            eppNotice.innerHTML = "EPP Partner's Inventory Discount";
            eppNotice.className = 'collection_product_card_price';
            eppNotice.style.color = 'green';
            eppNotice.style.fontSize = '0.9em';
            priceElement.parentNode.insertBefore(eppNotice, priceElement.nextSibling);

            priceElement.innerHTML = `$${discountedPrice}`;
            priceElement.style.color = 'green';
        } else if (eppSiteDiscount > 0) {
            const discountedPrice = (productPriceValue * (1 - eppSiteDiscount)).toFixed(2);

            const ogPrice = document.createElement('p');
            ogPrice.innerHTML = originalPriceHtml;
            ogPrice.className = 'collection_product_card_price';
            ogPrice.classList.add("eppPricing");
            ogPrice.classList.add("eppPricing" + priceContainerId);
            ogPrice.style.textDecoration = 'line-through';
            priceElement.parentNode.insertBefore(ogPrice, priceElement);

            const eppNotice = document.createElement('p');
            eppNotice.innerHTML = "EPP Partner Discount";
            eppNotice.className = 'collection_product_card_price';
            eppNotice.style.color = 'green';
            eppNotice.style.fontSize = '0.9em';
            priceElement.parentNode.insertBefore(eppNotice, priceElement.nextSibling);

            priceElement.innerHTML = `$${discountedPrice}`;
            priceElement.style.color = 'green';
        }
    }
}


    function fetchAndSetPricing(token){
            let pricingDiscount;
            fetch('https://apiapi.ombligo.com/getEPPCategories?token=' + token)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then(data => {
                    if (data.success) {
                      if (sessionStorage.getItem('eppPartner') !== data.partner) {
                          sessionStorage.setItem('eppPartner', data.partner);
                      }
                      if (sessionStorage.getItem('eppPartnerDiscount') !== data.pricing.partner) {
                        sessionStorage.setItem('eppSiteDiscount', data.pricing.partner);
                        pricingDiscount = data.pricing.partner;
                      }
                      if (sessionStorage.getItem('eppSiteDiscount') !== data.pricing.site) {
                          sessionStorage.setItem('eppSiteDiscount', data.pricing.site);
                      }
                      if (sessionStorage.getItem('eppCategories') !== data.categories) {
                          sessionStorage.setItem('eppCategories', data.categories);
                      }
                      if (sessionStorage.getItem('eppSiteDiscountCode') !== data.siteCode) {
                          sessionStorage.setItem('eppSiteDiscountCode', data.siteCode);
                      }
                      if (sessionStorage.getItem('eppPartnerDiscountCode') !== data.partnerCode) {
                          sessionStorage.setItem('eppPartnerDiscountCode', data.partnerCode);
                      }
                      try{
                        document.querySelector('#create_customer').classList.add('hide');
                        document.querySelector('.emailContainer').classList.add('hide');
                        document.getElementById('prodContainer').classList.remove('hide');
                        document.getElementById('titleNotLogin').classList.remove('hide');
                        document.getElementById("navContainer").classList.remove('hide');
                        document.getElementById('titleNotLogin').classList.add('secition-header-authenticated');
                        document.getElementById('body1').classList.remove('hide');

                      } catch (error) {

                      }
                      
                      // Trigger event to update product pricing
                      if (typeof window !== 'undefined') {
                          window.dispatchEvent(new CustomEvent('eppSessionUpdated'));
                      }
                      
                      return pricingDiscount;
                    } else {
                        console.log('Error:', data.error);
                    }
                })
                .catch(error => {
                    console.error('There was a problem with the fetch operation:', error);
                });
    
    return pricingDiscount;

    }


